import React from "react";
import { useTranslation } from "react-i18next";
import { LEGO_BRICK_TYPES } from "../../utils/brickOptimizer";
import { getColorHex } from "../../constants/bomPricing";
import BrickTypeShape from "./BrickTypeShape";

interface BrickInventory {
  brickType: (typeof LEGO_BRICK_TYPES)[0];
  colorIndex: number;
  colorName: string;
  quantity: number;
  estimatedPrice: number;
}

interface BOMDetailsProps {
  brickInventory: BrickInventory[];
  showCosts: boolean;
  formatCurrency: (amount: number) => string;
}

const BOMDetails: React.FC<BOMDetailsProps> = ({
  brickInventory,
  showCosts,
  formatCurrency,
}) => {
  const { t } = useTranslation();

  return (
    <div className="bom-details">
      <h4>{t("bom.detailedInventory")}</h4>

      <div className="inventory-table-container">
        <table className="inventory-table">
          <thead>
            <tr>
              <th>{t("bom.brickType")}</th>
              <th>{t("bom.color")}</th>
              <th>{t("bom.quantity")}</th>
              {showCosts && <th>{t("bom.unitPrice")}</th>}
              {showCosts && <th>{t("bom.totalPrice")}</th>}
            </tr>
          </thead>
          <tbody>
            {brickInventory.map((item, index) => (
              <tr key={index} className="inventory-row">
                <td className="brick-type-cell">
                  <BrickTypeShape
                    brickType={item.brickType}
                    colorName={item.colorName}
                  />
                </td>
                <td className="color-cell">
                  <div
                    className="color-swatch"
                    style={{ backgroundColor: getColorHex(item.colorName) }}
                  />
                  {item.colorName}
                </td>
                <td className="quantity-cell">
                  {item.quantity.toLocaleString()}
                </td>
                {showCosts && (
                  <td className="price-cell">
                    {formatCurrency(item.estimatedPrice)}
                  </td>
                )}
                {showCosts && (
                  <td className="total-cell">
                    {formatCurrency(item.estimatedPrice * item.quantity)}
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BOMDetails;
